module.exports = __webpack_public_path__ + "img/bottomImg.e200e5f8.png";